const AVAILABLE_ICONS = [
	'attention',
	'bell',
	'check',
	'close',
	'info-circle',
	'indeterminate',
] as const;

export type IconName = (typeof AVAILABLE_ICONS)[number];

export default AVAILABLE_ICONS;
